import React from 'react';
import './PasswordResetModal.css';
import '../../styles/App.css';

const ReusableModal = ({ 
  isOpen, 
  onClose, 
  onPrimaryAction, 
  title = "Modal Title", 
  message = "Modal message content.", 
  primaryButtonText = "Confirm",
  showPrimaryButton = true 
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-body">
          <h2 className="modal-title h4">{title}</h2>
          <p className="modal-message">
            {message}
          </p>
          {showPrimaryButton && (
            <button className="primary-action-button" onClick={onPrimaryAction}>
              {primaryButtonText}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ReusableModal;

// Backward compatibility export
export { ReusableModal as PasswordResetModal };